import * as HttpService from './HttpService'

let namespace = 'minuba-budgets-report'

const report = (options, cb, errorCb) => {
    HttpService.get(namespace, options, cb, errorCb)
}

export {
    report
}



// WEBPACK FOOTER //
// ./src/services/minubaBudgetService.js